
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { useState } from "../../composables/useState";

const MenuJob = defineComponent({
  name: "MenuJob",
  emits: [
    "deleteJob",
    "openChallenge",
    "openEvaluation",
    "deactivateJob",
    "assignJob",
  ],
  props: {
    jobId: {
      type: String,
      default: "",
    },
    hasChallenge: {
      type: Boolean,
      default: false,
    },
    hasEvaluation: {
      type: Boolean,
      default: false,
    },
    hasRecruiter: {
      type: Boolean,
      default: false,
    },
    showAssing: {
      type: Boolean,
      default: false,
    },
    isClosedJob: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const router = useRouter();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const deleteJob = () => {
      context.emit("deleteJob");
      setIsMenuOpen(false);
    };
    const deactivateJob = () => {
      context.emit("deactivateJob");
      setIsMenuOpen(false);
    };
    const openChallenge = () => {
      setIsMenuOpen(false);
      context.emit("openChallenge");
    };
    const openEvaluation = () => {
      setIsMenuOpen(false);
      context.emit("openEvaluation");
    };
    const assignJob = () => {
      setIsMenuOpen(false);
      context.emit("assignJob");
    };
    const closeMenu = () => {
      setIsMenuOpen(false);
    };
    return {
      isMenuOpen,
      setIsMenuOpen,
      closeMenu,
      deleteJob,
      openChallenge,
      openEvaluation,
      deactivateJob,
      assignJob,
      router,
    };
  },
});
export default MenuJob;
